import React from 'react';

import { Routes } from 'react-router-dom';

import { SentryRoute as Route } from '@vk-hr-tek/core/monitoring/SentryRoute';

import { PageError } from '../../../layout';
import { AuthById } from '../AuthById';
import { AuthList } from '../AuthList';

import { Login } from './Login';
import { VerifyInvite } from './VerifyInvite';
import { Register } from './Register';
import { ChangePassword } from './ChangePassword';
import { SendInvite } from './SendInvite';

export const GeneralAuth = (): JSX.Element => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path="invite" element={<VerifyInvite />} />
      <Route path="send-invite" element={<SendInvite />} />
      <Route path="change-password" element={<ChangePassword />} />
      <Route path="auth-list" element={<AuthList />} />
      <Route path=":id/*" element={<AuthById />} />
      <Route
        path="*"
        element={
          <div>
            <PageError status={404} />
          </div>
        }
      />
    </Routes>
  );
};
